import { API_URL } from '../../../../utils/config';

export const GET_ACCESS_POINTS_URL = `${API_URL}/accessPoints/list`;
export const GET_ACCESS_POINTS_BY_SSID_URL = `${API_URL}/accessPoints/findBySsid/1`;
export const GET_ACCESS_POINTS_BY_IP_URL = `${API_URL}/accessPoints/findByIp/1`;
export const ADD_ACCESS_POINT_URL = `${API_URL}/accessPoints/add`;
export const GET_ACCESS_POINT_CONNECTION_URL = `${API_URL}/acesspointconnection`;
